<script setup lang="ts">
import SpeakBinaryPage from "shared-ui/pages/SpeakBinaryPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    headerTitleKey: "shared_ui.tasks.speak_binary.title",
  },
});
</script>

<template>
  <SpeakBinaryPage />
</template>
